export default __webpack_public_path__ + "img/mission.1f6892ef.webp";